<app-iota-modal [title]="dialogTitle" [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body class="w-full">
        <!-- When adding or overriding an existing license -->
        <div class="flex flex-col gap-5" *ngIf="isAssignLicenseDialog">
            <app-smart-dialog-steps [stepLabels]="stepLabels" [currentStep]="currentStep"></app-smart-dialog-steps>

            <!-- First step: The table is shown to select the license -->
            <app-platform-license-table
                *ngIf="isInSelectLicenseStep"
                [platformLicenses]="platformLicensesThatCanBeAdded$ | ngrxPush"
                [licenseSelectionEnabled]="true"
                (selectedLicenseId)="selectLicense($event)"
            ></app-platform-license-table>

            <!-- Second step: Show form to adjust the dates -->
            <div class="flex flex-col gap-8" *ngIf="isInAdjustDatesStep">
                <div class="flex flex-col items-center gap-2">
                    <span class="text-lg font-bold" i18n>When does the license become valid?</span>
                    <span class="text-sm leading-6" i18n>
                        Please specify when the license should be activated. If the license is
                        <span class="font-bold">valid until further notice, no end date</span> needs to be set. The end date is optional.
                    </span>
                </div>
                <app-platform-license-activation-form
                    [platformLicenseActivation]="newPlatformLicenseActivation"
                    (formValid)="dateFormValid = $event"
                    #platformLicenseActivationForm
                >
                </app-platform-license-activation-form>
            </div>

            <!-- Third step: Show form to adjust the pricing -->
            <div class="flex flex-col gap-4" *ngIf="isInAdjustPricingStep">
                <div class="flex flex-col items-center gap-2">
                    <span class="text-lg font-bold" i18n>Use the original pricing or override it?</span>
                    <span class="text-sm text-center leading-6" i18n>
                        You can leave the pricing form as is, in this case the current pricing will always be taken from the license. If you
                        want to define a customer-specific pricing, you can do it here. The custom pricing will be saved automatically. If
                        you don't want to define a custom price, you can cancel the form via the button at the top.
                    </span>
                </div>
                <app-section-header>
                    <ng-container buttons>
                        <button *ngIf="!defineCustomPricing" (click)="enablePricingEditing()">
                            <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
                        </button>
                        <button *ngIf="defineCustomPricing" class="btn btn-accent" (click)="disablePricingEditing()">
                            <iota-icon icon="x-mark"></iota-icon>
                        </button>
                    </ng-container>
                </app-section-header>
                <app-platform-license-pricing-form
                    [platformLicense]="platformLicense$ | ngrxPush"
                    [platformLicensePricing]="customPricing"
                    [disableEffectiveDates]="true"
                    [editMode]="defineCustomPricing"
                    (formValid)="pricingFormValid = $event"
                    #platformLicensePricingForm
                ></app-platform-license-pricing-form>
            </div>

            <!-- Fourth step: Show the result -->
            <app-smart-dialog-result
                [loading]="actionLoading$ | ngrxPush"
                [error]="actionError"
                i18n-errorTitle
                errorTitle="Error"
                i18n-errorMessage
                errorMessage="Error while adding the license to the business partner."
                i18n-title
                title="Success"
                i18n-successMessage
                successMessage="Successfully added license to the business partner."
                *ngIf="isInResultStep"
            ></app-smart-dialog-result>
        </div>

        <!-- Default case, just show the form -->
        <ng-container *ngIf="isViewLicenseActivationDialog">
            <app-platform-license-form
                [platformLicense]="data?.platformLicenseActivation?.platformLicense"
                [editMode]="false"
            ></app-platform-license-form>
            <app-platform-license-pricing-form
                *ngIf="!!data?.platformLicenseActivation?.activePricing"
                [platformLicense]="data?.platformLicenseActivation?.platformLicense"
                [platformLicensePricing]="data?.platformLicenseActivation?.activePricing"
                [editMode]="false"
            ></app-platform-license-pricing-form
        ></ng-container>
    </div>

    <ng-container modal-footer>
        <div class="w-full flex flex-row items-center justify-between gap-5">
            <button
                class="btn btn-sm btn-ghost rounded-full flex flex-row items-center gap-2"
                (click)="closeDialog()"
                *ngIf="showCancelButton"
            >
                <span i18n>Cancel</span>
            </button>
            <button
                class="btn btn-sm btn-ghost rounded-full flex flex-row items-center gap-2"
                (click)="previousStep()"
                *ngIf="showBackButton"
            >
                <span i18n>Back</span>
            </button>
            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                (click)="nextStep()"
                [disabled]="!currentStepValid"
                *ngIf="showContinueButton"
            >
                <span i18n>Continue</span>
            </button>

            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [disabled]="!currentStepValid"
                (click)="addLicenseToBusinessPartner()"
                *ngIf="showSaveButton"
            >
                <span i18n>Save</span>
            </button>

            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                (click)="closeDialog()"
                *ngIf="isInResultStep"
            >
                <span i18n>Close</span>
            </button>
        </div>
    </ng-container>
</app-iota-modal>
